import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/styles";
import { Button, IconButton, InputAdornment, TextField } from "@material-ui/core";
import { Close, Search } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    searchWrap: {
        width: "100%",
        margin: theme.spacing(4, 1),
        [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(1, 4, 4, 4),
        },
    },
    btnSearch: {
        marginTop: theme.spacing(1),
    },
}));

const RSIOBIEKTYSearchFromAPi = (props) => {
    const { onSubmitSearch, onClearSearch, isError, isClear } = props;

    const classes = useStyles();
    const { t } = useTranslation();

    const [SEARCH_TEXT, setSEARCH_TEXT] = useState("");
    const [SEARCH_BUTTON, setSEARCH_BUTTON] = useState(false);
    const [SEARCH_CLEAR, setSEARCH_CLEAR] = useState(false);

    /** Handlers */
    const handleChange = (event) => {
        setSEARCH_TEXT(event.target.value);
    };

    const handleClear = () => {
        setSEARCH_TEXT("");
        onClearSearch();
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (SEARCH_TEXT.length >= 3) onSubmitSearch(SEARCH_TEXT);
    };

    useEffect(() => {
        setSEARCH_BUTTON(SEARCH_TEXT?.length >= 3);
        setSEARCH_CLEAR(SEARCH_TEXT.length);
    }, [SEARCH_TEXT]);

    useEffect(() => {
        if (isClear) handleClear();
        // eslint-disable-next-line
    }, [isClear]);

    return (
        <form onSubmit={handleSubmit} className={classes.searchWrap}>
            <TextField
                id="cechy-search-in-api"
                label={t("common.RSIOBIEKTYsearchObject")}
                value={SEARCH_TEXT}
                onChange={handleChange}
                variant="outlined"
                size={"small"}
                fullWidth
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <>
                                {!!SEARCH_CLEAR && (
                                    <IconButton size={"small"} onClick={handleClear}>
                                        <Close fontSize={"small"} />
                                    </IconButton>
                                )}
                            </>
                        </InputAdornment>
                    ),
                }}
                error={!!isError}
                helperText={!!isError ? isError.message : undefined}
            />
            {!!SEARCH_BUTTON && (
                <Button
                    size={"small"}
                    variant={"contained"}
                    disabled={!SEARCH_BUTTON}
                    color={"primary"}
                    startIcon={<Search fontSize={"small"} />}
                    fullWidth
                    type={"submit"}
                    className={classes.btnSearch}
                >
                    {t("Wyszukaj")}
                </Button>
            )}
        </form>
    );
};

export default RSIOBIEKTYSearchFromAPi;
